import { render, staticRenderFns } from "./MtReceipts.vue?vue&type=template&id=2d29a170&"
import script from "./MtReceipts.vue?vue&type=script&lang=js&"
export * from "./MtReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports